import { Badge } from "V2.0/common/badge";

export default function SlotTagsAvailable(props) {
  const { slotTags, onAvailableSlotTagSelect } = props;

  if (slotTags.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-4 border rounded-lg p-4">
      <p className="text-sm font-medium">Select Existing Slot Tags</p>
      <div className="flex flex-wrap gap-x-2">
        {slotTags.map((slotTag, idx) => {
          return (
            <Badge
              key={idx}
              className="hover:cursor-pointer hover:bg-zinc-800 hover:text-white"
              onClick={() => onAvailableSlotTagSelect(slotTag)}
            >
              {slotTag}
            </Badge>
          );
        })}
      </div>
    </div>
  );
}
